/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { SimulationData } from './SimulationData';
import {
    SimulationDataFromJSON,
    SimulationDataFromJSONTyped,
    SimulationDataToJSON,
    SimulationDataToJSONTyped,
} from './SimulationData';

/**
 * 
 * @export
 * @interface GetDetailedSimulationResponse
 */
export interface GetDetailedSimulationResponse {
    /**
     * List of simulation data entries containing product-level pricing data for the simulation.
     * @type {Array<SimulationData>}
     * @memberof GetDetailedSimulationResponse
     */
    simulationData: Array<SimulationData>;
    /**
     * Total count of simulation data entries.
     * @type {number}
     * @memberof GetDetailedSimulationResponse
     */
    totalCount: number;
}

/**
 * Check if a given object implements the GetDetailedSimulationResponse interface.
 */
export function instanceOfGetDetailedSimulationResponse(value: object): value is GetDetailedSimulationResponse {
    if (!('simulationData' in value) || value['simulationData'] === undefined) return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    return true;
}

export function GetDetailedSimulationResponseFromJSON(json: any): GetDetailedSimulationResponse {
    return GetDetailedSimulationResponseFromJSONTyped(json, false);
}

export function GetDetailedSimulationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDetailedSimulationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'simulationData': ((json['simulationData'] as Array<any>).map(SimulationDataFromJSON)),
        'totalCount': json['totalCount'],
    };
}

export function GetDetailedSimulationResponseToJSON(json: any): GetDetailedSimulationResponse {
    return GetDetailedSimulationResponseToJSONTyped(json, false);
}

export function GetDetailedSimulationResponseToJSONTyped(value?: GetDetailedSimulationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'simulationData': ((value['simulationData'] as Array<any>).map(SimulationDataToJSON)),
        'totalCount': value['totalCount'],
    };
}

